import { Box, Button, Stack } from "@mui/material";
import * as Sentry from "@sentry/react";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { ErrorComponent, rootRouteId, useMatch, useRouter } from "@tanstack/react-router";
import { LinkButton } from "./tanstack-link";

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter();
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId,
  });

  Sentry.captureException(error);

  return (
    <Box>
      <ErrorComponent error={error} />
      <Stack spacing={2} sx={{ pl: 1 }} direction="row">
        <Button
          onClick={() => {
            router.invalidate();
          }}
          variant="outlined"
        >
          Try Again
        </Button>
        {isRoot ? (
          <LinkButton to="/">Home</LinkButton>
        ) : (
          <Button
            onClick={(e) => {
              e.preventDefault();
              window.history.back();
            }}
          >
            Go Back
          </Button>
        )}
      </Stack>
    </Box>
  );
}
